import { getVideoPlatformRows } from "../../lib/platformStatus";

export const LIFECYCLE_FILTERS = [
  { value: "all", label: "All", count: "total" },
  { value: "unedited", label: "Unedited", count: "unedited" },
  { value: "editing", label: "Editing", count: "editing" },
  { value: "ready", label: "Ready", count: "ready" },
  { value: "blocked", label: "Blocked", count: "blocked" },
  { value: "free_promo", label: "Free promo", count: "freePromo" },
  { value: "archived", label: "Archived", count: "archived" },
];

export const PUBLISHING_FILTERS = [
  { value: "all", label: "All" },
  { value: "presale", label: "Presale" },
  { value: "live_subs", label: "Live subs" },
  { value: "on_sale", label: "On sale" },
  { value: "store_enabled", label: "Store" },
  { value: "members", label: "Members" },
  { value: "vip", label: "VIP" },
  { value: "bts", label: "BTS" },
];

export function getLifecycleState(video) {
  const status = video?.edit_status || "pending";
  if (["edited", "ready"].includes(status)) return "ready";
  if (["edit_now", "semi_edited", "editing", "in_progress"].includes(status)) return "editing";
  if (status === "no_publishing") return "blocked";
  if (status === "free_promo") return "free_promo";
  if (status === "archived") return "archived";
  return "unedited";
}

export function matchesLifecycleFilter(video, filter) {
  return filter === "all" || getLifecycleState(video) === filter;
}

export function matchesPlatformFilter(video, platform) {
  return platform === "all" || getVideoPlatformRows(video).some((row) => row.key === platform);
}

export function matchesPublishingFilter(video, filter) {
  if (filter === "all") return true;

  const rows = getVideoPlatformRows(video);
  const statuses = rows.map((row) => row.status);
  if (filter === "presale") return statuses.some((status) => ["presale", "presale_dm", "presale_post"].includes(status));
  if (filter === "live_subs") return statuses.some((status) => ["live_sub", "live_on_subs", "published", "re_published"].includes(status));
  if (filter === "on_sale") return statuses.includes("on_sale");
  if (filter === "store_enabled") return Boolean(video?.store_enabled) || rows.some((row) => row.key === "video_store");
  if (filter === "members") return (video?.visibility || []).includes("members") || statuses.some((status) => ["free_members", "basic_members"].includes(status));
  if (filter === "vip") return (video?.visibility || []).includes("vip") || statuses.includes("vip_members");
  if (filter === "bts") return (video?.visibility || []).includes("bts") || statuses.includes("bts");
  return false;
}

export function getLifecycleCounts(videos = []) {
  const counts = {
    total: videos.length,
    unedited: 0,
    editing: 0,
    ready: 0,
    blocked: 0,
    freePromo: 0,
    archived: 0,
    platformReady: 0,
  };

  for (const video of videos) {
    const lifecycle = getLifecycleState(video);
    if (lifecycle === "free_promo") counts.freePromo += 1;
    else counts[lifecycle] += 1;
    if (getVideoPlatformRows(video).some((row) => ["scheduled", "published", "live_on_subs", "re_published"].includes(row.status))) {
      counts.platformReady += 1;
    }
  }

  return counts;
}